// @flow

import styled, { css } from 'styled-components'
import { Loader } from '@alphaott/smart-tv-components'
import { isWebOS4 } from '@alphaott/smart-tv-platforms/src/utils/getDeviceType'
import { Flex } from '@rebass/grid'

export const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export const CentralContainer = styled(Flex)`
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`

export const ErrorAlertContainer = styled(Flex)`
  justify-content: center;
  position: absolute;
  top: 40rem;
  left: 0;
  width: 100%;
  z-index: 10;
`

// Animated overlays can stall live video on webOS 4 while it is buffering.
// Keep the loading indicator visible without continuously compositing it.
export const PlaybackLoader = styled(Loader)`
  ${isWebOS4 &&
  css`
    & > div {
      animation: none;
    }
  `}
`
